import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggingService } from './logging.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  private logging = inject(LoggingService);

  handleError(error: any): void {
    const errorMsg = this.formatErrorMsg(error);
    this.logging.logError(errorMsg, error);
  }

  private formatErrorMsg(error: any) {
    if (error instanceof HttpErrorResponse) {
      return `GlobalErrorHandler.handleError failed: type="HttpErrorResponse", status=${error.status}, url="${error.url || 'N/A'}", message="${error.message}"`;
    }

    if (error instanceof Error) {
      const stackPreview = error.stack ? error.stack.substring(0, 200) : 'N/A';
      return `GlobalErrorHandler.handleError failed: type="Error", name="${error.name}", message="${error.message}", stack="${stackPreview}"`;
    }

    if (typeof error === 'string') {
      return `GlobalErrorHandler.handleError failed: type="String", message="${error}"`;
    }

    if (typeof error === 'object' && error !== null) {
      const errorName = error.name || 'Unknown';
      const errorMessage = error.message || JSON.stringify(error).substring(0, 200);
      return `GlobalErrorHandler.handleError failed: type="Object", name="${errorName}", message="${errorMessage}"`;
    }

    return `GlobalErrorHandler.handleError failed: type="${typeof error}", value="${String(error)}"`;
  }
}
